import { User } from '@client/_blessed/store/entities/users/model';

export const formatDrayUsersDropdown = (users: User[]) => {
  if (!users) {
    return [];
  }

  return users.map((user) => ({ value: user.uuid, label: `${user.firstName} ${user.lastName}` }));
};
